import vsComponent from './vsRow';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
